export default __webpack_public_path__ + "static/media/shape4mobile.30522f86.svg";